import { IoCheckmarkCircle } from "react-icons/io5";

export default function LastTransaction({ title, date, amount, status }) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-[0px_4px_20px_rgba(0,0,0,0.02)] border border-gray-100 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center text-green-600 text-lg flex-shrink-0">
          <IoCheckmarkCircle className="text-2xl" />
        </div>
        <div>
          <h4 className="text-gray-800">{title}</h4>
          <p className="text-gray-500 mt-0.5">{date}</p>
        </div>
      </div>

      <div className="text-right flex-shrink-0">
        <p className="text-xl text-gray-800">₺{amount}</p>
        <span className="inline-block text-[10px] font-bold bg-green-100 text-green-600 px-2 py-0.5 rounded-md mt-0.5 uppercase tracking-wider">
          {status}
        </span>
      </div>
    </div>
  );
}
